import { Injectable } from "@angular/core";
import { BaseDataService, HttpService } from "./base.service";
import { ItemContainerMaterial } from "../..";

@Injectable()
export class ItemContainerMaterialService extends BaseDataService<ItemContainerMaterial> {
  constructor(http: HttpService) {
    super(http, "itemcontainermaterial");
  }

  createInstance(options: any): ItemContainerMaterial {
    return new ItemContainerMaterial(options);
  }

  getActive() {
    return this.http.request(`${this.resourceUrl}/active`);
  }
}
